import { useLang } from "../i18n";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-line bg-ink-2/60 overflow-hidden" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 pt-16 pb-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6">
            <img
              src="/images/hadron-logo.png"
              alt="Hadron Energy"
              className="h-36 w-auto"
              data-testid="footer-logo"
            />
            <p className="mt-5 max-w-md text-sm text-txt-2 leading-relaxed">{f.tagline}</p>
            <p className="mt-5 font-mono2 text-[10px] uppercase tracking-[0.2em] text-hadron-cyan flex flex-wrap items-center gap-2">
              Singapore <span className="w-8 h-px bg-line inline-block" /> China <span className="w-8 h-px bg-line inline-block" /> Poland
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="mono-label !text-[9px]">Contact</p>
            <ul className="mt-4 space-y-2.5 text-sm text-txt-2">
              <li>Podolany 88, 32-420 Gdów, Poland</li>
              <li><a href="tel:+48122002588" className="hover:text-hadron-cyan transition-colors">+48 12 2002 588</a></li>
              <li><a href="mailto:contact@hadronenergy.pl" className="hover:text-hadron-cyan transition-colors break-all">contact@hadronenergy.pl</a></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="mono-label !text-[9px]">Legal</p>
            <ul className="mt-4 space-y-2.5 text-sm text-txt-2">
              <li><a href="/knowledge/" data-testid="footer-knowledge-link" className="hover:text-hadron-cyan transition-colors">EV Knowledge Hub (AI)</a></li>
              <li><a href="#/privacy" data-testid="footer-privacy-link" className="hover:text-hadron-cyan transition-colors">{f.privacy}</a></li>
              <li><a href="#/imprint" data-testid="footer-imprint-link" className="hover:text-hadron-cyan transition-colors">{f.imprint}</a></li>
              <li className="text-txt-3">{f.hub}</li>
            </ul>
          </div>
        </div>

        <p className="mt-12 font-display lowercase font-bold leading-none tracking-tight text-[clamp(3rem,11vw,10rem)] text-white/[0.045] select-none" data-testid="footer-wordmark">
          hadron energy
        </p>

        <div className="mt-6 pt-6 border-t border-line flex flex-col md:flex-row gap-3 md:items-center justify-between">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.18em] text-txt-3">
            © {year} Hadron Energy Poland sp. z o.o. — {f.rights}
          </p>
          <p className="text-[11px] text-txt-3 max-w-xl">{f.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
};
